import axios from 'axios';
import { API_HOST } from '../config.env';
import { me } from '../helpers';

export const edit = (userData, access) => {
    return axios.put(`${API_HOST}/api/users/${me().id}`, userData, {
        headers: {
            Accept: 'application/ld+json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access}`
        }
    });
}
